const IconChip = ({ feature }) => (
    <div
        className="relative flex items-center justify-center mb-0 flex-shrink-0 w-full max-w-60 max-h-[245px] aspect-[240/245]"
    >
        {/* Background chip image */}
        <img
            src="/images/feature-chip.svg"
            alt=""
            className="absolute inset-0 z-0 w-full h-full object-contain"
        />
        
        {/* Icon */}
        <img
            src={`/images/icons/${feature.icon}.svg`}
            alt={feature.title}
            className={`relative z-10 w-full h-auto max-w-40 icon-${feature.icon}`}
            onError={(e) => {
                e.target.src = '/images/icons/dummy.svg';
            }}
        />
    </div>
);

const TextContent = ({ feature, isOnTop = false }) => (
    <div className={`flex flex-col items-center justify-start w-full px-0 mt-2 feature-text-container ${isOnTop ? 'is-on-top' : ''}`}>
        {/* Title */}
        <h3 className="feature-title">
            {feature.title}
        </h3>
        
        {/* Content */}
        <p
            className="feature-text"
            lang="de"
        >
            {feature.content}
        </p>
    </div>
);

const FeaturesOutput = ({
    DATA,
    toggleMode = false,
    dataAos = "fade-up",
    dataAosDuration = "600",
    dataAosDelay = "300",
    delayStepTime = "250",
}) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 py-8 px-4">
            {DATA.map((feature, index) => {
                const showTextOnTop = toggleMode && index % 2 === 1;
                const itemDelay = parseInt(dataAosDelay, 10) + index * parseInt(delayStepTime, 10);

                return (
                    <div
                        key={index}
                        className="flex flex-col items-center justify-start h-full min-h-[400px]"
                        data-aos={dataAos}
                        data-aos-duration={dataAosDuration}
                        data-aos-delay={itemDelay}
                    >
                        {showTextOnTop && <TextContent feature={feature} isOnTop />}
                        <IconChip feature={feature} />
                        {!showTextOnTop && <TextContent feature={feature} />}
                    </div>
                );
            })}
        </div>
    )
}

export default FeaturesOutput
